import { MARKER_TYPES } from '@/utils/constants';
import { formatTime } from '@/utils/date';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'marker-card',
})

export default class MarkerCardComponent extends Vue {

    // ----------------------------------------------------
    // Properties

    @Prop({default: false})
    private isExpanedView!: boolean ;

    @Prop()
    private marker: any;


    // ----------------------------------------------------
    // Actions

    private onShowRouteInfo() {
        this.$emit('onShowRouteInfo', this.marker);
    }

    private onSelectRoute() {
        this.$emit('onSelectRoute', this.marker);
    }


    // ------------------------------------------------------
    // Actions

    private formatTime(value: number = 0) {
        return formatTime(value);
    }


}
